import type { TypedContainer } from '@thinkalpha/common/ioc/TypedContainer.js';
import type { StaticBindings } from 'src/types/bindings';

export type StaticContainer = TypedContainer<StaticBindings>;

// We choose to not extend the `globalThis` so that we are forced to import the container instead of using a global
export const container =
    typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope
        ? (self.container as unknown as StaticContainer)
        : ((globalThis as any).container as StaticContainer);

export { container as staticContainer };
